import React from 'react';
import { Button, Div } from '@vkontakte/vkui';
import DefaultPanel from "../classes/DefaultPanel";
import LoaderSpinner from "../components/LoaderSpinner";
import Icon16Clear from '@vkontakte/icons/dist/16/clear';
import Icon16CheckCircle from '@vkontakte/icons/dist/16/check_circle';
import { connect } from "react-redux";
import { backMoneyTransaction } from "../services/db";
import { setBillRefund } from "../store/bills/actions";


class PanelRefundProcess extends DefaultPanel {

	state = {
		status: 0,  // 0 - in progress, 1 - success, 2 - fail
        error: '',
	};

	settings() {
		this.title = 'Результат возврата';
		this.theme = 'gray';
		this.hasSwipe = false;
	}

    openBills = () => {
        this.openPage('main');
    };

    backMoney = async() => {
        this.setState({ status: 0 });
        // Делаем операцию возврата
        const backResult = await this.props.dispatch(backMoneyTransaction(this.props.transactionId, this.props.sum));
        // Если успешно
        if (backResult.data.data.result !== undefined && backResult.data.data.result === 'success') {
            this.setState({ status: 1 });
        	// Изменяем массив
		    this.props.dispatch(setBillRefund(this.props.transactionId, backResult.data.data.sum, backResult.data.data.date_refund));
        } else {
            this.setState({ status: 2, error: backResult.data.data.error });
        }
    };

	componentWillMount() {
        this.backMoney();
	}

	renderPanel() {
        let errorTxt = '';
        switch (this.state.error) {
            case 'ERR_REFUND_FAILED':
                errorTxt = 'Возврат не удался. Попробуйте ещё раз';
                break;
            case 'ERR_TRANSACTION_NOT_FOUND':
                errorTxt = 'Транзакция с переданным идентификатором не найдена. Обратитесь к сотрудникам VK Pay';
                break;
            case 'ERR_AMOUNT_GREATER_THAN_ALLOWED':
                errorTxt = 'Сумма, которую Вы хотите вернуть, больше суммы платежа. Введите корректное значение';
                break;
            case 'ERR_ALREADY_REFUNDED':
                errorTxt = 'Платёж уже возвращён';
                break;
            case 'ERR_NOMONEY':
                errorTxt = 'На Вашем счёте недостаточно средств для возврата';
                break;
            case 'ERR_ACCESS_DENIED':
                errorTxt = 'Нет доступа к указанной транзакции. Обратитесь к сотрудникам VK Pay';
                break;
			case 'ERR_RATE_LIMIT':
                errorTxt = 'Превышено допустимое число возвратов по одной транзакции. Обратитесь к сотрудникам VK Pay';
				break;
            case 'transaction_already_back':
                errorTxt = 'Платёж уже возвращён';
                break;
            case 'wrong_transaction':
                errorTxt = 'Неверная транзакция. Обратитесь к сотрудникам VK Pay';
                break;
            case 'unknown':
                errorTxt = 'Неизвестная ошибка. Обратитесь к сотрудникам VK Pay';
                break;
            default:
                errorTxt = 'Неизвестная ошибка, код (' + this.state.error + '). Обратитесь к сотрудникам VK Pay';
                break;
        }

		const inProcess =
			<div>
				<LoaderSpinner/>
				<div>Возврат средств...</div>
			</div>;

        const success =
            <div>
				<div className="icon-success"><Icon16CheckCircle/></div>
                <div className="text">Успешно</div>
				<Div className="btn-back"><Button size="xl" onClick={ this.openBills }>Назад</Button></Div>
            </div>;

        const fail =
            <div>
				<div className="icon-fail"><Icon16Clear/></div>
                <div className="text">Не удалось</div>
                <div className="error">Ошибка: { errorTxt }</div>
                <Div>
				    <div className="btn-again"><Button size="xl" onClick={ this.backMoney }>Еще раз</Button></div>
				    <div className="btn-back"><Button size="xl" level="secondary" onClick={ this.openBills }>Назад</Button></div>
                </Div>
            </div>;

		return(
			<React.Fragment>
				<div className="center-block">
					{ this.state.status === 0 && inProcess }
					{ this.state.status === 1 && success }
					{ this.state.status === 2 && fail }
				</div>
			</React.Fragment>
		)
	}
}

function mapStateToProps(state) {
    return {
        sum: state.bills.refund.sum,
        transactionId: state.bills.refund.transactionId,
    };
}

export default connect(mapStateToProps)(PanelRefundProcess);


// WEBPACK FOOTER //
// ./src/js/panels/PanelRefundProcess.js